import { detDistance } from "./math";
import type { Point } from "./map-data";

/**
 * Strike zone sizes, shared by the sim and the client previews.
 * Each constant is a tuning knob (world units). See docs/design/air-strike-controls.html.
 */
export const strikeZones = {
  /** Drone circle radius per sqrt(drone count): 1 → 70, 3 → 121, 8 → 198. */
  droneRadiusPerRoot: 70,
  /** Bomber corridor length along the heading. */
  bomberRunLength: 300,
  /** Corridor width for one bomber, plus this much per extra bomber flying side by side. */
  bomberRunWidth: 110,
  bomberRunWidthPerExtra: 50,
  /** Missile: full damage inside fullRadius, linear falloff to edge damage at falloffRadius. */
  missileFullRadius: 160,
  missileFalloffRadius: 220,
  /** Most aircraft one strike command may carry. */
  maxStrikeSize: 12,
} as const;

export const droneStrikeRadius = (count: number): number =>
  strikeZones.droneRadiusPerRoot * Math.sqrt(Math.max(1, count));

export const bomberRunWidth = (count: number): number =>
  strikeZones.bomberRunWidth + strikeZones.bomberRunWidthPerExtra * (Math.max(1, count) - 1);

export const missileFlightTime = (origin: Point, target: Point, speed: number): number =>
  detDistance(origin, target) / speed;
